import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { BankOnboardingPage } from '@/features/banks-products';

/** Guided onboarding: new bank → first product → optional schemes → configuration draft v1. */
export const Route = createFileRoute('/_app/banks/new')({
  staticData: { crumb: 'banksProducts:onboarding.crumb' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'config.edit', 'Setup'),
  component: function NewBank() {
    const navigate = Route.useNavigate();
    return (
      <BankOnboardingPage
        onDone={({ bankId, product, versionNo }) => void navigate({ to: '/banks/$bankId/products/$productId/versions/$versionNo', params: { bankId, productId: product, versionNo: String(versionNo) } })}
        onCancel={() => void navigate({ to: '/banks' })}
      />
    );
  },
});
